export const backupChecksHeaderElements = [
  { label: "Fecha", value: "fecha", align: "inherit" },
  { label: "Titular cuenta", value: "titular", align: "inherit" },
  { label: "Nro. cuenta", value: "nroCuenta", align: "inherit" },
  { label: "Monto", value: "monto", align: "inherit" },
  { label: "Solicitante", value: "solicitante", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];